import PropTypes from "prop-types";

const LookupScreen = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
<div className="fixed top-0 left-0 right-0 bg-white z-50 max-h-[calc(100vh-4rem)] overflow-auto font-sora">
<div className="bg-secondary p-6">
        <div className="relative">
        <img
          src="/src/assets/search.svg"
          alt="search-icon"
          className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5"
        />
        <input
          type="text"
          placeholder="Search"
          className="pl-10 pr-4 py-4 w-full rounded-3xl text-sm font-light bg-gray-200 text-gray-600 focus:outline-none"
        />
        </div>
      </div>

      <div className="p-4 bg-gray-100 min-h-screen">
        <h2 className="font-bold text-lg">Popular Searches</h2>
        <div className="mt-2">
          <div className="bg-white p-4 rounded-lg shadow-md w-32 flex flex-col items-center">
            <img
              src="/path-to-manchester-city-logo.png"
              alt="Manchester City"
              className="w-12 h-12"
            />
            <span className="text-sm mt-1 font-medium">Manchester City</span>
          </div>
        </div>

        <h2 className="font-bold text-lg mt-6">Available Competitions</h2>
        <div className="bg-white tetxt-sm rounded-2xl shadow-md mt-2">
          {[
            { flag: "🇬🇧", name: "England - Premier League" },
            { flag: "🇫🇷", name: "France - Ligue 1" },
            { flag: "🇩🇪", name: "Germany - Bundesliga" },
            { flag: "🇮🇹", name: "Italy - Serie A" },
            { flag: "🇳🇱", name: "Netherlands - Eredivisie" },
            { flag: "🇪🇸", name: "Spain - La Liga" },
          ].map((comp, index) => (
            <div key={index} className="p-4 border-b border-gray-200 last:border-none">
              <span className="mr-2">{comp.flag}</span>
              {comp.name}
            </div>
          ))}
        </div>
      </div>

      <button
        className="absolute top-28 right-4 bg-gray-200 p-2 text-xs rounded-full"
        onClick={onClose}
      >
       x Close Search
      </button>
    </div>
  );
};

LookupScreen.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LookupScreen;
